function getTrackerName() {
  if (window && window.ga) {
    const tracker = typeof window.ga.getAll === 'function' ? window.ga.getAll()[0] : null;
    return tracker.get('name');
  }

  return '';
}

export default getTrackerName;
